const initialState = {
  listRules: [],
  loadingBranches: false,
  loadingTable: true,
  alertId: null,
  myRule: null,
  branchItems: [],
  newRule: {
    name: null,
    rules: [
      {
        email: null,
        justComment: false,
        alerts: [
          { grade: 0, value: false },
          { grade: 1, value: false },
          { grade: 2, value: false },
          { grade: 3, value: false },
          { grade: 4, value: false },
          { grade: 5, value: false },
          { grade: 6, value: false },
          { grade: 7, value: false },
          { grade: 8, value: false },
          { grade: 9, value: false },
          { grade: 10, value: false },
        ],
      },
    ],
    level1: {
      email: null,
      days: null,
    },
    level2: {
      email: null,
      days: null,
    },
    level3: {
      email: null,
      days: null,
    },
  },
};

export default initialState;



// WEBPACK FOOTER //
// ./src/store/modules/settings/alert-rules/initialState.js